import { Component, OnInit } from '@angular/core';
import {Authority} from "../../../../../admin/components/dictionary/region-education-authorities/dictionary-authority";
import {CollegeRegionService} from "../../../../services/college-region.service";
import {Language} from "../../../../../../common/models/language";
import {LangChange} from "../../../../../../lang-change";
import {CollegeCountByType} from "../../models/CollegeCountByType";
import {CollegeCountByForm} from "../../models/CollegeCountByForm";
import {CollegeCountByCities} from "../../models/CollegeCountByCities";
import {CollegeInfoService} from "../../../../services/college-info.service";
import {Principal} from "../../../../../../common/services/principal";
import {CommonMainLayoutComponent} from "../../../common-main-layout/common-main-layout.component";
import {TranslateService} from '@ngx-translate/core';

class OptionsData {
  value: number;
  name: string;
}

@Component({
  selector: 'app-petropavl',
  templateUrl: './petropavl.component.html',
  styleUrls: ['./petropavl.component.scss']
})
export class PetropavlComponent extends LangChange implements OnInit {

  regionInfo: Authority = new Authority();
  lang: string;
  options1: any = {};
  options2: any = {};
  options3: any = {};
  optionsData1: OptionsData[];
  optionsData2: OptionsData[];

  collegeCountByType: CollegeCountByType[];
  collegeCountByForms: CollegeCountByForm[];
  collegeCountByCities: CollegeCountByCities[];

  onLangChange(language: Language): void {
    this.lang = language['code'];
    this.loadSummaryData();
  }

  constructor(private collegeInfoService: CollegeInfoService,
              _translateService: TranslateService,
              private _principal: Principal,
              private commonMainLayoutComponent: CommonMainLayoutComponent,
              private collegeRegionService: CollegeRegionService) {
    super(_translateService);
    this.lang = Language.getCurrentLanguage().code;
  }

  ngOnInit() {
    this.collegeRegionService.getCollegeRegionInfo().subscribe(res => {
      if(res) {
        this.regionInfo = res['collegeRegionInfo'];
        Language.getLocalizedNameObject(this.regionInfo);
        // console.log('this.regionInfo', this.regionInfo)
      }
    })
    this.loadSummaryData();
  }


  loadSummaryData() {
    this.collegeInfoService.getSummaryData(this.lang).subscribe(response => {
        this.collegeCountByType = response['collegeCountByType'];
        this.collegeCountByForms = response['collegeCountByForm'];
        this.collegeCountByCities = response['collegeCountByCities'];
        this.setUpoOptionsData();
      }
    );
  }

  setUpoOptionsData() {
    this.optionsData1 = this.collegeCountByType.filter(u => u.collegeTypeId > 0).map(u => ({
      value: u.count,
      name: u.collegeType
    }));
    this.options1 = {
      title: {
        text: this._translateService.instant('diagram.college_count_by_type'),
        left: 'center',
        textStyle: {
          color: '#6e6e6e'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
        // formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        padding: [50, 0, 0, 0],
        orient: 'horizontal',
        y: 'bottom',
        x: 'center'
        // data: ['1', '2', '3']
      },
      series: [
        {
          name: 'Universities',
          type: 'pie',
          radius: '60%',
          labelLine: {
            length: 5,
            length2: 5
          },
          center: ['50%', '50%'],
          data: this.optionsData1,
          itemStyle: {
            emphasis: {
              shadowBlur: 20,
              shadowOffsetX: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    this.optionsData2 = this.collegeCountByForms.map(u => ({value: u.count, name: u.name}));
    this.options2 = {

      // backgroundColor: '#2c343c',

      title: {
        text: this._translateService.instant('diagram.college_count_by_form'),
        left: 'center',
        textStyle: {
          color: '#6e6e6e'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
        // formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        padding: [50, 0, 0, 0],
        orient: 'horizontal',
        y: 'bottom',
        x: 'center'
        // data: ['1', '2', '3']
      },
      series: [
        {
          name: 'Universities',
          type: 'pie',
          radius: '60%',
          labelLine: {
            length: 5,
            length2: 5
          },
          center: ['50%', '50%'],
          data: this.optionsData2,
          itemStyle: {
            emphasis: {
              shadowBlur: 20,
              shadowOffsetX: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };

    const optionsValues = [];
    const optionsNames = [];
    this.collegeCountByCities.forEach(u => optionsValues.push(u.count));
    this.collegeCountByCities.forEach(u => optionsNames.push(u.name));

    const labelOption = {
      normal: {
        show: true,
        position: 'top',
        distance: 5,
        align: 'left',
        verticalAlign: 'middle',
        rotate: '90',
        formatter: '{b}',
        fontSize: 13,
        textStyle: {
          color: '#6e6e6e'
        },
        rich: {
          /*name: {
              textBorderColor: '#fff'
          }*/
        }
      }
    };

    this.options3 = {
      title: {
        text: this._translateService.instant('diagram.college_count_by_region'),
        left: 'center',
        textStyle: {
          color: '#6e6e6e'
        }
      },
      color: ['#61a0a8'],
      tooltip: {},
      grid: {
        top: '25%',
        left: '2%',
        right: '3%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: optionsNames,
          show: false,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series:
        [
          {
            // name: 'Университеты',
            type: 'bar',
            barWidth: '80%',
            label: labelOption,
            data: optionsValues
          }
        ]
    }
    ;
    /*this.options3 = {
      color: ['#009cd9', '#a68ff5', '#4CAF50', '#FF7043', '#f44336', '#607D8B', '#FFEE58', '#00BCD4', '#0D47A1', '#DD2C00'],
      grid: {
        top: 150
      },
      tooltip: {
        formatter: "{a} : {c} colleges"
        /!*trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }*!/
      },
      legend: {
        orient: 'horizontal',
        y: 'top'
      },
      /!*    toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              // dataView: {show: true, readOnly: false},
              // magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              // restore: {show: true},
              saveAsImage: {show: true}
            }
          },*!/
      calculable: true,
      xAxis: [
        {
          type: 'category',
          // nameGap:10,
          // show:false,
          axisPointer: {
            show: false
          }, axisLabel: {
            rotate: 40,
          },
          axisTick: {show: false},
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: series
    };*/
    /*  this.options3 = {
        tooltip: {
          /!* trigger: 'axis',
           axisPointer: {
               type: 'shadow'
           }*!/
        },
        legend: {
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.03]
        },
        yAxis: {
          type: 'category',
          data: this.optionsData3.names
        },
        series: [
          {
            name: 'Universities',
            type: 'bar',
            data: this.optionsData3.values
          }
        ]
      };*/
    /*let series: any = this.collegeCountByCities.map(u => ({
  name: u.name,
  type: 'bar',
  // label: labelOption,
  data: [u.count]
}));*/
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/main/pages/petropavl/petropavl.component.ts